import {currencyFormatter, rupiah, formatTime} from 'utils/formatter'

class ShiftDetailTotalExpense extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      collapseExpense: false
    }
  }
  componentWillReceiveProps (nextProps) {
    this.setState({collapseExpense: false})
  }
  render () {
    let {shift} = this.props
    return (<div className='row'>
      <div className='col-sm-12'>
        {(shift.total_expense <= 0) && <div className='form-group col-sm-12 label-section' id='collapsibleExpense'>
          <div>
            <a className='collapsed disable'>
              <label>TOTAL EXPENSE</label>
              <div>{currencyFormatter(shift.total_expense)}</div>
            </a>
          </div>
        </div>}
        {(shift.total_expense > 0) && <div className='form-group col-sm-12 label-section' id='collapsibleExpense'>
          <div>
            <a className={(!this.state.collapseExpense && 'collapsed')} data-toggle='collapse' onClick={this._onClickCollapseExpense}>
              <label>TOTAL EXPENSE</label>
              <div><span>(</span>{currencyFormatter(shift.total_expense)}<span>)</span></div>
            </a>
          </div>
          {this.state.collapseExpense && <div>
            <ul>
              {shift.shift_details.map((detail, idx) => {
                return (detail.type === 'Expense') && <li key={idx}>
                  <div>
                    <label className={`detail-description text-elipsis`}>{formatTime(detail.created_at)} - {detail.description}</label>
                    <div className={``}>
                      <span> ({rupiah(detail.amount)})</span>
                    </div>
                  </div>
                </li>
              })}
            </ul>
          </div>}
        </div>}
      </div>
    </div>)
  }
  _onClickCollapseExpense = () => {
    this.setState({collapseExpense: !this.state.collapseExpense})
  }
}

ShiftDetailTotalExpense.propTypes = {
  shift: React.PropTypes.object,
  shiftDetails: React.PropTypes.array
}

export default (ShiftDetailTotalExpense)



// WEBPACK FOOTER //
// ./app/pages/Reports/Shift/ShiftDetail/ShiftDetailModal/ShiftDetailTotalExpense/ShiftDetailTotalExpense.js